<template>
  <div class="page-box">
    <PageSwiper location="BUSINESS"/>

    <div class="page-nav">
      <img src="@/assets/home-icon.png" />
      <div style="cursor: pointer;" @click="$router.replace({name: 'home'})">首页 > </div>
      <div style="padding-left: 6px;cursor: pointer;" @click="$router.replace({name: 'bizScope'})">业务范畴 > </div>
      <div class="text">业务详情</div>
    </div>

    <div class="biz-box">
      <div class="title">{{ bizData.name }}</div>
      <div v-html="$utils.escape2Html(bizData.content)"></div>
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
export default {
  components: { PageSwiper },
  data() {
    return {
      bizData: {}
    }
  },
  created() {
    this.getBizData()
  },
  methods: {
    gotoHome() {
      if (localStorage.getItem('isFromHome') == 1) {
        this.$router.back()
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    getBizData() {
      this.$http.getAction(`/portal/api/v1/business/scope/detail/${this.$route.params.id}`).then((res) => {
        if (res.success) {
          this.bizData = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-box {
  padding-bottom: 100px;
  background: #F5F5F5;
  flex: 1;

  .page-nav {
    display: flex;
    align-items: center;
    height: 80px;
    width: 1200px;
    font-weight: 500;
    font-size: 14px;
    color: #898989;
    margin: 0 auto;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    .text {
      padding-left: 6px;
      color: #333333;
    }
  }

  .biz-box {
    width: 1000px;
    background: #FFFFFF;
    margin: 0 auto;
    padding: 40px 100px;
    .title {
      margin: 0 auto;
      width: 770px;
      font-weight: 800;
      font-size: 26px;
      color: #000000;
      line-height: 30px;
      text-align: center;
      padding-bottom: 25px;
    }
    .time {
      font-weight: 500;
      font-size: 12px;
      color: #5A5A5A;
    }
  }
  
}
</style>
